import { Pipe, PipeTransform } from '@angular/core';
import { Store } from '@ngxs/store';
import { Observable, isObservable, of } from 'rxjs';
import { switchMap } from 'rxjs/operators';
import { IDynamicActionsBrickEntry } from '../components/bricks/dynamic-actions-brick/dynamic-actions-brick-configuration/dynamic-actions-brick-configuration';
import { DynamicActionsBehaviorState } from '../store/dashboard/brick-wall/brick-behaviour-state/brickTypes/dynamic-actions-behavior/dynamic-actions-behavior.state';

@Pipe({
   name: 'isDynamicActionExecutable',
})
export class IsDynamicActionExecutablePipe implements PipeTransform {
   constructor(private store: Store) {}

   transform(dynamicAction: IDynamicActionsBrickEntry | Observable<IDynamicActionsBrickEntry>): Observable<boolean> {
      const dynamicAction$ = isObservable(dynamicAction) ? dynamicAction : of(dynamicAction);
      return dynamicAction$.pipe(
         switchMap((actionEntry) =>
            this.store.select(DynamicActionsBehaviorState.getActionIsExecutable).pipe(switchMap((isExecutable) => isExecutable(this.store, actionEntry)))
         )
      );
   }
}
